import { request } from '../api.js';
import type {
  AddParticipantsRequest,
  ConversationDetailDto,
  ConversationListItemDto,
  CreateGroupChatRequest,
  EditMessageRequest,
  InboxUnreadResponse,
  ListMessagesQuery,
  MessageDto,
  PostMessageRequest,
} from '@cosvision/shared';

export function listConversations(): Promise<ConversationListItemDto[]> {
  return request<ConversationListItemDto[]>('get', '/conversations');
}

export function getInboxUnread(): Promise<InboxUnreadResponse> {
  return request<InboxUnreadResponse>('get', '/conversations/unread-count');
}

export function createDm(userId: string): Promise<ConversationDetailDto> {
  return request<ConversationDetailDto>('post', '/conversations/direct', { userId });
}

export function createGroupChat(body: CreateGroupChatRequest): Promise<ConversationDetailDto> {
  return request<ConversationDetailDto>('post', '/conversations/group', body);
}

export function getConversation(id: string): Promise<ConversationDetailDto> {
  return request<ConversationDetailDto>('get', `/conversations/${id}`);
}

export function addParticipants(
  id: string,
  body: AddParticipantsRequest,
): Promise<ConversationDetailDto> {
  return request<ConversationDetailDto>('post', `/conversations/${id}/participants`, body);
}

export function markConversationRead(id: string): Promise<{ read: boolean }> {
  return request<{ read: boolean }>('post', `/conversations/${id}/read`);
}

export function listMessages(
  id: string,
  opts: Partial<ListMessagesQuery> = {},
): Promise<MessageDto[]> {
  const params = new URLSearchParams();
  if (opts.after) params.set('after', opts.after);
  if (opts.limit) params.set('limit', String(opts.limit));
  const qs = params.toString();
  return request<MessageDto[]>(
    'get',
    qs ? `/conversations/${id}/messages?${qs}` : `/conversations/${id}/messages`,
  );
}

export function sendMessage(id: string, body: PostMessageRequest): Promise<MessageDto> {
  return request<MessageDto>('post', `/conversations/${id}/messages`, body);
}

export function editMessage(
  id: string,
  msgId: string,
  body: EditMessageRequest,
): Promise<MessageDto> {
  return request<MessageDto>('patch', `/conversations/${id}/messages/${msgId}`, body);
}

export function deleteMessage(id: string, msgId: string): Promise<MessageDto> {
  return request<MessageDto>('delete', `/conversations/${id}/messages/${msgId}`);
}

export function searchMessages(id: string, q: string): Promise<MessageDto[]> {
  return request<MessageDto[]>(
    'get',
    `/conversations/${id}/messages/search?q=${encodeURIComponent(q)}`,
  );
}
